import React from "react"
import GamingFooter from "../footer/GamingFooter"
import CustomPermissions from "../permissions/CustomPermissions"
import CustomTitle from "../title/CustomTitle"

function GamingConsent({ id, rrn, ticket, consents, redirect }) {
  const GamingTitle = <CustomTitle merchantName={ticket.tp.name} />
  const GamingPermissions = (
    <CustomPermissions sharedInformation={ticket.tp.sharedInformation} />
  )

  return (
    <>
      {GamingTitle}
      <div className="container-flex">{GamingPermissions}</div>
      <GamingFooter id={id} rrn={rrn} opt={consents} redirect={redirect} />
    </>
  )
}

export default GamingConsent
